/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'envelope': {
    width: 23,
    height: 18,
    viewBox: '0 0 23 18',
    data: '<path pid="0" d="M22.55 5.705c.18-.135.45 0 .45.225v9.164a2.157 2.157 0 01-2.156 2.156H2.156A2.129 2.129 0 010 15.094V5.93c0-.225.225-.36.404-.225 1.033.809 2.336 1.797 6.918 5.121.944.674 2.56 2.156 4.178 2.156 1.572 0 3.234-1.482 4.133-2.156 4.582-3.324 5.885-4.312 6.918-5.12zM11.5 11.5c-1.078.045-2.56-1.303-3.324-1.842C2.2 5.346 1.752 4.941.404 3.863.134 3.683 0 3.37 0 3.01v-.854C0 .988.943 0 2.156 0h18.688C22.012 0 23 .988 23 2.156v.854c0 .36-.18.674-.45.853-1.347 1.078-1.796 1.483-7.77 5.795-.764.54-2.247 1.887-3.28 1.842z" _fill="#3E4749"/>'
  }
})
